var map = {
	"./app-icon.svg": 1717,
	"./caret-right-icon.svg": 1718,
	"./chrome-icon.webp": 1719,
	"./edge-icon.webp": 1720,
	"./firefox-icon.webp": 1721,
	"./opera-icon.webp": 1722,
	"./safari-icon.webp": 1723,
	"./unknown-icon.webp": 1724
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1716;